<template>
  <SystemDesigner />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
